export default {"src":"/_next/static/media/forgotPasswordImage.b93be21e.svg","height":145,"width":162,"blurWidth":0,"blurHeight":0};